import { unescape } from "lodash-es";

export const decodeAgentDisplayText = ({ value }: { value: string }) => unescape(value);
